module.exports = __webpack_public_path__ + "static/media/line.892d49d2.svg";